/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-multi-str */

export const PageBreakWidget: any = (SurveyKo: any) => {
  return {
    name: `pagebreak`,
    title: 'Page Break',
    iconName: 'icon-editor',
    type: 'pagebreak',

    widgetIsLoaded() {
      return true;
    },
    isFit(question: { getType: () => string }) {
      return question.getType() === 'pagebreak';
    },

    init() {
      SurveyKo.Serializer.addClass('pagebreak', [], undefined, 'empty');
      SurveyKo.JsonObject.metaData.addProperties('pagebreak', [
        { name: 'hideNumber', default: true },
      ]);
    },

    isDefaultRender: true,

    afterRender(
      question: {
        value: string;
        title: string;
        valueChangedCallback: () => void;
        isReadOnly: any;
        readOnlyChangedCallback: () => void;
      },
      el: {
        getElementsByClassName: (arg0: string) => any;
        getElementsByTagName: (arg0: string) => any;
      },
    ) {
      let editor = el.getElementsByClassName('pagebreak');

      if (editor.length === 0) return;
      editor = editor[0];
      editor.innerHTML = `<div></div>`;
    },
  };
};
